export const PERSON_ROLE_TYPE_OPTIONS = [
  { value: 'CEO', text: 'CEO' },
  { value: 'CFO', text: 'CFO' },
  { value: 'CB', text: 'Co-Beneficiary (50%)' },
  { value: 'CSP', text: 'CSP Representative' },
  { value: 'D', text: 'Director' },
  { value: 'MJ', text: 'Major Beneficiary (>50%)' },
  { value: 'MB', text: 'Minor Beneficiary (>50%)' },
  { value: 'PS', text: 'Primary Signatory' },
  { value: 'SH', text: 'Shareholder' },
  { value: 'UBO', text: 'Ultimate Beneficial Owner' },
  { value: '-', text: 'Unknown' },
] as const;

export type PersonRoleType =
  | (typeof PERSON_ROLE_TYPE_OPTIONS)[number]['value']
  | '';
